import { Component } from '@verndale/core';
import anime from 'animejs/lib/anime.es';
import createScrollShapes from '../helpers/createScrollShapes';

class HeroBlock extends Component {
  setupDefaults() {
    this.dom = {
      contentContainer: this.el.querySelector('.hero-block__columns'),
      scrollBudy: this.el.querySelector(
        '.hero-block__scroll-budy svg line'
      )
    };

    this.buildShapes();
    this.animateScrollBudy();
  }

  buildShapes() {
    this.dom.shapes = createScrollShapes({
      containerEl: this.dom.contentContainer,
      count: 3,
      prefix: 'hero-block__',
      scrollAnimate: false
    });
  }

  animateScrollBudy() {
    const tl = anime.timeline({
      easing: 'linear',
      duration: 200,
      endDelay: 400,
      loop: true
    });

    tl.add({
      targets: this.dom.scrollBudy,
      strokeWidth: [0, 2]
    });

    tl.add(
      {
        targets: this.dom.scrollBudy,
        y2: [12, 24]
      },
      '-=200'
    );

    tl.add({
      targets: this.dom.scrollBudy,
      y1: [12, 24]
    });

    tl.add(
      {
        targets: this.dom.scrollBudy,
        strokeWidth: [2, 0]
      },
      '-=200'
    );
  }
}

export default HeroBlock;
